import {PlayableAction} from "./types";
import {
  ChoiceUserInputAction,
  ChoiceUserInputBranch,
  Scalars,
  UserInputAction
} from "../../schema";
import {phraseToText} from "../../components/Phrase";
import {isChoiceUserInputAction, isUserInputAction} from "../../types";

export function isAnyUserInputAction(action: PlayableAction): action is (ChoiceUserInputAction | UserInputAction) {
  return isUserInputAction(action) || isChoiceUserInputAction(action);
}

export function isFreeSpeech(action: PlayableAction): boolean {
  switch (action.__typename) {
    case "UserInputAction":
      return action.freeSpeech ? action.freeSpeech : false;
    case "ChoiceUserInputAction":
      return false;
    default:
      return false;
  }
}

export function getTextFromAction(action: PlayableAction): string {
  let text: string;

  switch (action.__typename) {
    case "UserInputAction":
      text = action.hintText !== "" ? action.hintText : action.referenceText;
      break;
    case "AvatarAction":
    case "SystemAction":
      text = action.text;
      break;
    case "ChoiceUserInputAction":
      text = action.branches[0].userInput.referenceText;
      break;
    default:
      throw new Error(`getTextFromAction not implemented for type ${action.__typename}`);
  }

  return phraseToText(text);
}

export function getBranch(rootAction: PlayableAction, branchId: Scalars["ID"]):
  ChoiceUserInputBranch | undefined {
  if (rootAction.__typename === "ChoiceUserInputAction") {
    return rootAction.branches.find(b => b.id === branchId);
  }

  return undefined;
}

export function getBranchActions(
  branch: ChoiceUserInputBranch,
): PlayableAction[] | undefined {
  if (branch.__typename === "ChoiceUserInputBranch") {
    return [branch.avatarReaction, branch.systemReaction].filter((action) => !!action) as PlayableAction[];
  }

  return undefined;
}

export function _next(actions: PlayableAction[], level: number, index: number): number | undefined {
  const totalActions = actions.length;

  for (let i = index + 1; i <= totalActions; i++) {
    if (i >= totalActions) {
      return undefined;
    }

    return i;
  }
}
